/**
 * Fix mega-menu mobile accordion for L2 groups.
 *
 * Problem: The theme JS relies on transitionend events on
 * ul.list-menu--disclosure-2, which doesn't exist in mega-menu HTML
 * (it uses div.site-nav-sub instead). This breaks sibling toggling.
 * Also, the theme's e.stopPropagation() blocks bubble-phase listeners.
 *
 * Solution: Use CAPTURE phase listener (fires before bubble phase,
 * cannot be blocked by stopPropagation) to properly toggle siblings.
 */
(function () {
  'use strict';

  // Use capture phase so stopPropagation in theme.js can't block us
  document.addEventListener('click', function (e) {
    // Match clicks on the L2 link text, icon, or any child element
    var link = e.target.closest('.menu_mobile_link_2');
    if (!link) return;

    // Only act inside the mobile sidebar mega-menu
    var megamenu = link.closest('.halo-sidebar_menu .megamenu_style_1');
    if (!megamenu) return;

    var siteNav = link.closest('.site-nav');
    if (!siteNav) return;

    // Toggle: if already open, close it; otherwise open it
    if (siteNav.classList.contains('is-open')) {
      siteNav.classList.remove('is-open');
      // Restore siblings
      var allGroups = siteNav.parentElement.querySelectorAll(':scope > .site-nav');
      allGroups.forEach(function (s) {
        s.classList.remove('is-hidden');
        s.classList.remove('d-none');
      });
    } else {
      // Hide all sibling groups, open this one
      var allGroups = siteNav.parentElement.querySelectorAll(':scope > .site-nav');
      allGroups.forEach(function (s) {
        if (s !== siteNav) {
          s.classList.remove('is-open');
          s.classList.add('is-hidden');
          s.classList.remove('d-none');
        }
      });
      siteNav.classList.remove('is-hidden');
      siteNav.classList.add('is-open');
      siteNav.classList.remove('d-none');
    }

    // Scroll the mega-menu panel to top
    var menuDropdown = link.closest('.menu-dropdown');
    if (menuDropdown) {
      menuDropdown.scrollTop = 0;
      menuDropdown.classList.add('is-overflow');
    }
  }, true); // <-- CAPTURE phase: fires before jQuery's bubble-phase handlers

  // Fix the back button for mega-menu L3 panels
  document.addEventListener('click', function (e) {
    var backBtn = e.target.closest('.halo-sidebar_menu .megamenu_style_1 .site-nav-sub .nav-title-mobile');
    if (!backBtn) return;

    var siteNav = backBtn.closest('.site-nav.is-open');
    if (!siteNav) return;

    // Close this group
    siteNav.classList.remove('is-open');
    siteNav.classList.remove('d-none');

    // Restore all siblings
    var allGroups = siteNav.parentElement.querySelectorAll(':scope > .site-nav');
    allGroups.forEach(function (s) {
      s.classList.remove('is-hidden');
      s.classList.remove('d-none');
    });

    // Remove overflow lock
    var menuDropdown = backBtn.closest('.menu-dropdown');
    if (menuDropdown) {
      menuDropdown.classList.remove('is-overflow');
    }
  }, true); // capture phase
})();
